import WorkflowConfigurationService from '@/utils/workflow-configuration-service';
import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildWorkflowConfigurationGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const getConfiguration = buildWorkflowConfigurationGetterObject('getConfiguration');
export const getConfigurationFieldsIdsPerInterface = buildWorkflowConfigurationGetterObject('getConfigurationFieldsIdsPerInterface');
export const getConfigurationResponse = buildWorkflowConfigurationGetterObject('getConfigurationResponse');
export const getConfigurationFieldResponse = buildWorkflowConfigurationGetterObject('getConfigurationFieldResponse');
export const getConfigurationInterface = buildWorkflowConfigurationGetterObject('getConfigurationInterface');
export const getConfigurationInterfaceIdByFieldUUID = buildWorkflowConfigurationGetterObject('getConfigurationInterfaceIdByFieldUUID');
export const getSingleConfigurationInterfaceId = buildWorkflowConfigurationGetterObject('getSingleConfigurationInterfaceId');
export const getConfigurationFieldsIds = buildWorkflowConfigurationGetterObject('getConfigurationFieldsIds');

const getters = {
	[getConfiguration.getter]: (state) => (configurationId) => state.data[configurationId],
	[getConfigurationFieldsIdsPerInterface.getter]: (state, getters) => (configurationId, fieldType) =>
		WorkflowConfigurationService.getConfigurationFieldsIdsPerInterface(getters[getConfiguration.getter](configurationId), { fieldType }),
	[getConfigurationResponse.getter]: (state, getters) => (configurationId) =>
		getters[getConfiguration.getter](configurationId)?.user_response?.fields_responses,
	[getConfigurationFieldResponse.getter]: (state, getters) => (configurationId, fieldUUID) =>
		getters[getConfigurationResponse.getter](configurationId)?.[fieldUUID],
	// DO NOT USE THIS - WE NEED A SIGLE SOURCE OF TRUTH FROM THE WIDGETS STORE
	[getConfigurationInterface.getter]: (state, getters) => (configurationId, interfaceUUID) =>
		getters[getConfiguration.getter](configurationId)?.workflow_configuration_interfaces.find(
			(configInterface) => configInterface.interface.id === interfaceUUID
		)?.interface,
	// DO NOT USE THIS - WE NEED A SIGLE SOURCE OF TRUTH FROM THE WIDGETS STORE
	[getConfigurationInterfaceIdByFieldUUID.getter]: (state, getters) => (configurationId, fieldUUID) => {
		const workflow_configuration_interfaces = getters[getConfiguration.getter](configurationId)?.workflow_configuration_interfaces || [];

		for (const configuration_interface of workflow_configuration_interfaces) {
			const foundField = configuration_interface?.interface?.fields.find((field) => field.id === fieldUUID);
			if (foundField) {
				return configuration_interface?.interface?.id;
			}
		}
	},
	[getSingleConfigurationInterfaceId.getter]: (state, getters) => (configurationId) =>
		getters[getConfiguration.getter](configurationId)?.workflow_configuration_interfaces[0].interface.id,
	[getConfigurationFieldsIds.getter]:
		(state, getters) =>
		(configurationId, fieldType = null) =>
			WorkflowConfigurationService.getConfigurationFieldsIds(getters[getConfiguration.getter](configurationId), { fieldType }),
};

export default getters;
